import { convertTime } from "../../../helper/isWithin15Minutes";

export function hasContestDurationEnded(startTime, durationInMinutes) {
  const contestOverTime =
    new Date(startTime).valueOf() +
    convertTime("mintoms", durationInMinutes || 0);

  return Date.now() >= contestOverTime;
}
